import React, { Component } from "react";
import {format_without_time, toInt, getTimeInIST, format_date_only, format_fancy, format_display_DDMMYYYY, formatNumber} from '../../Utils';
import {Table, Well, Glyphicon} from 'react-bootstrap';
import moment from 'moment';
import "../../css/agentreport.css";
import XLSX from 'xlsx';
import TransactionDetails from  "../../TransactionDetails";
import {UserService} from '../../Services/UserService';
import { ReportService } from "../../Services/ReportService";
import Paper from '@material-ui/core/Paper';
import EnhancedTableHead from '../../components/EnhancedTableHead';
import TableBody from '@material-ui/core/TableBody';
import { withStyles } from '@material-ui/core/styles';
import TablePagination from '@material-ui/core/TablePagination';
import { RowCountOptions } from "../../Config";
import { Typography, Button, Grid, TextField } from "@material-ui/core";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import MomentUtils from '@date-io/moment';
import { Autocomplete } from "@material-ui/lab";

const styles = theme =>({
    root: {
      width: '100%',
      marginTop: theme.spacing(3),
    },
    tablecell: {
        fontSize: '40pt'
    }
  });

class AgentReport extends Component {

    constructor(props) {
      super(props);
      this.state = {
        data: [],
        current_rows: [],
        startDate: moment().subtract(7, "days"),
        endDate: moment(),
        message : "",
        userList: [],
        selectedAgent: {},
        numItemsPerPage: RowCountOptions[0],
        currentPageNumber: 0,
        totalItems: 0,
        totalPages: 0,
        summaryRows: [],
        sheet1: "Summary",
        sheet2: "Delivery details",
        filename: "HappyMilk - Agent Transactions",
        totalCount : {},
        totalAmount: 0,
        total_returns: 0,
        transactionModal: null,
        columns : [
            { id: 'route_id', numeric: false, disablePadding: false, label: 'Route', sortable: false },
            { id: 'schedule_date', numeric: false, disablePadding: false, label: 'Schedule Date' , sortable: false },
            { id: 'customer_name', numeric: false, disablePadding: false, label: 'Customer' , sortable: false },
            { id: 'product_name', numeric: false, disablePadding: false, label: 'Product', sortable: false  },
            { id: 'product_qty', numeric: true, disablePadding: false, label: 'Qty', sortable: false  },
            { id: 'total_amount', numeric: true, disablePadding: false, label: 'Total Amount', sortable: false  },
            { id: 'delivered_count', numeric: true, disablePadding: false, label: 'Delivered Count', sortable: false  },
            { id: 'returned_count', numeric: true, disablePadding: false, label: 'Returned Count', sortable: false  },
            { id: 'reason', numeric: false, disablePadding: false, label: 'Reason', sortable: false  },
            // { id: 'bottles_returned', numeric: false, disablePadding: false, label: 'Bottles Returned Count' , sortable: false },
            { id: 'delivery_date', numeric: false, disablePadding: false, label: 'Delivery Date', sortable: false  }
        ],
        order: "schedule_date",
        orderBy: "asc"
      }

      props.setTitle('Agent Delivery Report');

      this.handleSelect = this.handleSelect.bind(this);
      this.handleChangeStart = this.handleChangeStart.bind(this);
      this.handleChangeEnd = this.handleChangeEnd.bind(this);
      this.export = this.export.bind(this);
      this.today = this.today.bind(this);
      this.viewTransactions = this.viewTransactions.bind(this);
    }
    
    componentWillMount(){
        this.props.isLoading(true);
        UserService.getAgentList()
        .then((data) => {
            console.log(data);
            this.setState({userList: data.users});
            this.props.isLoading(false);
        })
        .catch(error => {
            console.log(error);
            this.props.isLoading(false);
        });
    }

    today(e){
        e.preventDefault();
        if(this.state.selectedAgent.id){
            this.setState({ 
                startDate: moment(),
                endDate: moment()
            }, () => {
                this.fetchData();
            });
        }
    }

    viewTransactions(e, report){
        console.log(report);
        this.setState({transactionModal: null}, ()=> {
            let transactionModal = <TransactionDetails report={report} agent_id={this.state.selectedAgent.id} startDate={this.state.startDate} endDate={this.state.endDate} />;
            this.setState({transactionModal: transactionModal});
        });
    }

    sortBy = (event, property) => {
    }

    handleChangeRowsPerPage = event => {
        this.setState({ numItemsPerPage : event.target.value }, () => this.fetchTransactions(0, this.state.numItemsPerPage));
    }

    handleChangePage = (event, page) => {
        if(this.state.currentPageNumber > page){
            this.fetchRow(this.state.currentPageNumber - 1);
        } else {
            this.fetchRow(this.state.currentPageNumber + 1);
        }
    };

    fetchData(){
        if(this.state.selectedAgent.id){
            this.props.isLoading(true);
            ReportService.getReportAgentTotalTransactions(this.state.selectedAgent.id, this.state.startDate, this.state.endDate)
            .then((data) => {
                console.log(data);
                this.setState({
                    totalItems: data.count, 
                    totalPages: Math.ceil(data.count / this.state.numItemsPerPage) - 1,
                    currentPageNumber: 0,
                    message: "",
                    totalCount : data.total_count,
                    totalAmount: data.total_amount,
                    total_returns: data.total_returns
                });
                if(data.count === 0) {
                    this.setState({message: "No Transactions available."});
                }
                this.fetchSummary();
                this.fetchTransactions(0, this.state.numItemsPerPage);
            })
            .catch(error => {
                console.log(error);
                this.props.isLoading(false);
            });
        }
    }

    reset = () => {
        this.setState({
            totalItems: 0, 
            totalPages: 0,
            currentPageNumber: 0,
            message: "",
            totalCount : 0,
            totalAmount: 0,
            total_returns: 0,
            data: [], 
            summaryRows: [], 
            summary: [], 
            current_rows: []
        });
    }

    export(e){
        if(this.state.selectedAgent.id && this.state.totalItems > 0){
            e.preventDefault();
            
            ReportService.getReportAgentTransactions(this.state.selectedAgent.id, this.state.startDate, this.state.endDate, 0, this.state.totalItems)
                .then((data) => {
                    let exportSummaryData = [["From", moment(this.state.startDate).format(format_without_time)]];
                    exportSummaryData.push(["To", moment(this.state.endDate).format(format_without_time)]);
                    exportSummaryData.push([]);
                    exportSummaryData.push(["SL.NO", "Product", "Actual Count", "Delivered Count", "Returned Count"]);
                    this.props.isLoading(true);

                    let actualCountTotal = 0, deliveredCountTotal = 0, returnedCountTotal = 0;
                    this.state.summary.forEach((report, index) => {
                        let prodArray = [index + 1, report.product, toInt(report.actual_count), toInt(report.delivered_count), toInt(report.returned_count)];
                        actualCountTotal += toInt(report.actual_count);
                        deliveredCountTotal += toInt(report.delivered_count);
                        returnedCountTotal += toInt(report.returned_count);
                        exportSummaryData.push(prodArray);
                    });

                    exportSummaryData.push(["", "Total", toInt(actualCountTotal), toInt(deliveredCountTotal), toInt(returnedCountTotal)])
                    
                    let exportDetailedTransactionData = [["From", moment(this.state.startDate).format(format_without_time)]];
                    exportDetailedTransactionData.push(["To", moment(this.state.endDate).format(format_without_time)]);
                    exportDetailedTransactionData.push([]);
                    exportDetailedTransactionData.push(["Route", "Schedule Date", "Customer", "Product", "Qty", "Total Amount", "Delivered Count", "Returned Count", "Reason", "Delivery Date"]);

                    data.transactions.forEach((transaction, index) => {
                        let prodArray = [transaction.route_id, moment(transaction.schedule_date).format(format_without_time), transaction.store_name, transaction.product_name, toInt(transaction.product_qty), toInt(transaction.total_amount), toInt(transaction.delivered_count), toInt(transaction.returned_count), transaction.reason, transaction.delivery_date];
                        exportDetailedTransactionData.push(prodArray);
                    });

                    const wb = XLSX.utils.book_new();
                    const wsAll = XLSX.utils.aoa_to_sheet(exportSummaryData);
                    const wsAllDetailed = XLSX.utils.aoa_to_sheet(exportDetailedTransactionData);
                    XLSX.utils.book_append_sheet(wb, wsAll, this.state.sheet1);
                    XLSX.utils.book_append_sheet(wb, wsAllDetailed, this.state.sheet2);
                    XLSX.writeFile(wb, this.state.filename + ".xlsx");
                    this.props.isLoading(false);
                })
                .catch(error => {
                    this.props.isLoading(false);
                });
        }
    }

    fetchSummary(){
        ReportService.getReportAgentTransactionsSummary(this.state.selectedAgent.id, this.state.startDate, this.state.endDate)
        .then((data) => {
            console.log(data);
            let a = [];
            data.report.forEach((report) => {
                a.push(<ReportDetails key={report.product} report={report} viewTransactions={this.viewTransactions}/>);
            });
            this.setState({summaryRows: a, summary: data.report});
        })
        .catch(error => {
            console.log(error);
            this.props.isLoading(false);
        });
    }

    fetchTransactions(start, numberItems){
        
        ReportService.getReportAgentTransactions(this.state.selectedAgent.id, this.state.startDate, this.state.endDate, start, numberItems)
        .then((data) => {
            let rows = [];
            console.log(data);
            this.setState({data: data.transactions});
            data.transactions.forEach((transaction) => {
                rows.push(<AgentTransactionDetails key={transaction.id} transaction={transaction}/>);
            });
            this.setState({
                current_rows: rows
            });
            this.props.isLoading(false);
        })
        .catch(error => {
            console.log(error);
            this.props.isLoading(false);
        });
    }

    handleSelect(eventKey, e) {
        if(eventKey === 'prev'){
            if((this.state.currentPageNumber) > 0){
                this.fetchRow(this.state.currentPageNumber - 1);
            }
        } else if(eventKey === 'next'){
            if((this.state.currentPageNumber) < this.state.totalPages){
                this.fetchRow(this.state.currentPageNumber + 1);
            }
        }
    }

    fetchRow(newCurrentPage){
        this.fetchTransactions(newCurrentPage * this.state.numItemsPerPage, this.state.numItemsPerPage);
        this.setState({ currentPageNumber: newCurrentPage });
    }

    handleChangeStart(date){
        this.setState({
            startDate: date,
            startOpen: false
        });
    }

    handleChangeEnd(date){
        this.setState({
            endDate: date,
            endOpen: false
        });
    }

    handleSelection = (e, selected) => {
        this.setState({selectedAgent : selected}, () => this.reset());
    }
    
    render() {
        const message = this.state.message;
        const {classes} = this.props;
        return (
            <div className="Home agent_report" style={{marginTop: 32}}>
                <Paper style={{paddingTop: 8, paddingBottom: 8}}>
                    <Grid container style={{paddingLeft: 8, paddingRight: 8}}>
                        <Grid item xs={12} lg={4} style={{marginTop: 16}}>
                            {/* <Typeahead
                                    onChange={(selected) => {
                                        console.log(selected);
                                        this.setState({ selectedAgent: selected[0] });
                                        this.reset();
                                    }}
                                    options={this.state.userList}
                                    labelKey="name"
                                    placeholder="Choose a Agent"
                                    clearButton
                                /> */}
                            <Autocomplete
                                id="agent-selection"
                                disableClearable
                                options={this.state.userList}
                                getOptionLabel={option => (option && option.name) || ''}
                                value={this.state.selectedAgent || null}
                                required={true}
                                onChange={this.handleSelection}
                                className={classes.autoCompleteSelectionTextField}
                                style={{ zIndex: 9999 }}
                                renderInput={params => (
                                    <TextField {...params} label="Select Agent" variant="outlined" fullWidth />
                                )}
                                />
                        </Grid>
                        <Grid item xs={6} lg={2}>
                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                <DatePicker
                                        variant="inline"
                                        inputVariant="outlined"
                                        margin="normal"
                                        open={this.state.startOpen || false}
                                        label="From"
                                        onOpen={() => this.setState({startOpen: true})}
                                        onClose={() => this.setState({startOpen: false})}
                                        value={this.state.startDate}
                                        onChange={this.handleChangeStart}
                                        format={format_date_only}
                                        maxDate={this.state.endDate}
                                        className={classes.formControl}
                                        InputLabelProps={{
                                            style: { zIndex: 'auto' }
                                        }}
                                    />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={6} lg={2}>
                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                <DatePicker
                                    variant="inline"
                                    inputVariant="outlined"
                                    margin="normal"
                                    open={this.state.endOpen || false}
                                    label="To"
                                    onOpen={() => this.setState({endOpen: true})}
                                    onClose={() => this.setState({endOpen: false})}
                                    value={this.state.endDate}
                                    onChange={this.handleChangeEnd}
                                    format={format_date_only}
                                    minDate={this.state.startDate}
                                    className={classes.formControl}
                                    InputLabelProps={{
                                        style: { zIndex: 'auto' }
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={12} lg={4} style={{marginTop: 24}}>
                            <Button variant="outlined" style={{marginRight: 8}} color="primary" onClick={(e) => { this.today(e)}}>TODAY</Button>
                            <Button variant="outlined" style={{marginRight: 8}} onClick={(e) => { this.fetchData(e)}}>Generate</Button>
                            <Button variant="contained" color="primary" disabled={this.state.data.length === 0} onClick={this.export}>Export</Button>
                        </Grid>
                    </Grid>
                    </Paper>
                    {
                        this.state.totalItems > 0 &&
                        <Paper style={{paddingTop: 8, paddingBottom: 8, marginTop: 20}}>
                            <div> 
                                <Typography variant="h5" color="primary">Summary</Typography>
                                <Well style={{margin: 8}}>{`Total Items Delivered: ${this.state.totalCount.delivered_count_total} | Total Sales: ${formatNumber(this.state.totalAmount)} | Total Returns: ${formatNumber(this.state.total_returns)}`}</Well>
                                <Table striped condensed hover responsive style={{maxWidth: "100%", marginTop: 32, margin: 8, width: '99%'}}>
                                    <thead>
                                        <tr>
                                            <th>Product</th>
                                            <th>Actual Count</th>
                                            <th>Delivered Count</th>
                                            <th>Returned Count</th>
                                            {/* <th>Bottles Returned Count</th> */}
                                            <th>View Transactions</th>
                                        </tr>
                                    </thead>
                                    <tbody style={{textAlign: "left"}}>
                                        {this.state.summaryRows}
                                    </tbody>
                                </Table>
                            </div>
                        </Paper>
                    }
                    {/* { this.state.totalPages > 0 && 
                        <Pager>
                            <Pager.Item previous disabled={this.state.currentPageNumber  === 0}  eventKey="prev" onSelect={this.handleSelect} href="#">
                                &larr; Previous Page {this.state.currentPageNumber  === 0 ? "" : this.state.currentPageNumber }
                            </Pager.Item>
                            <Pager.Item next disabled={this.state.currentPageNumber  === this.state.totalPages} eventKey="next" onSelect={this.handleSelect} href="#" >
                                Next Page {this.state.currentPageNumber  === this.state.totalPages ? "": this.state.currentPageNumber + 2} &rarr;
                            </Pager.Item>
                        </Pager>
                    } */}
                    { this.state.current_rows.length > 0 && !this.props.loading &&
                        <Paper style={{paddingTop: 8, paddingBottom: 8, marginTop: 20}}>
                            <div style={{margin: 8}}>
                                <Typography variant="h5" color="primary">Detailed Transactions</Typography>
                                <Table striped condensed hover responsive>
                                    <EnhancedTableHead
                                        order={this.state.order}
                                        orderBy={this.state.orderBy}
                                        onRequestSort={this.sortBy}
                                        rows ={this.state.columns} />
                                    <TableBody>
                                    {this.state.current_rows}
                                    </TableBody>
                                </Table>
                                <TablePagination
                                    rowsPerPageOptions={RowCountOptions}
                                    component="div"
                                    count={this.state.totalItems}
                                    rowsPerPage={this.state.numItemsPerPage}
                                    page={this.state.currentPageNumber}
                                    backIconButtonProps={{
                                        'aria-label': 'Previous Page',
                                    }}
                                    nextIconButtonProps={{
                                        'aria-label': 'Next Page',
                                    }}
                                    onChangePage={this.handleChangePage}
                                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                    />
                            </div>
                        </Paper>
                    }
                    {
                        message && 
                        (
                            <p style={{color:"red", marginTop: '10vh'}}>{message}</p>
                        )
                    }
                    {this.state.transactionModal}
            </div>
        );
    }

}

class ReportDetails extends Component {

    render(){
        const report = this.props.report;
        // const isBottled = report.bottled === "1" ? true : false;
        return (
            <tr>
                <td>{report.product}</td>
                <td>{report.actual_count}</td>
                <td>{report.delivered_count}</td>
                <td>{report.returned_count}</td>
                {/* <td>{isBottled ? report.bottles_returned : "NA"}</td> */}
                <td>
                    { report.actual_count !== report.delivered_count &&
                        <Glyphicon style={{marginRight: "10px"}} glyph="book" onClick={(e) => this.props.viewTransactions(e, report)} />
                    }
                </td>
            </tr>
        );
    }
}

class AgentTransactionDetails extends Component {

    render(){
      const transaction = this.props.transaction;
      return (
        <tr>
            <td>{transaction.route_id}</td>
            <td>{moment(transaction.schedule_date).format(format_display_DDMMYYYY)}</td>
            <td align="left">{transaction.store_name}</td>
            <td align="left">{transaction.product_name}</td>
            <td>{transaction.product_qty}</td>
            <td>{formatNumber(transaction.total_amount)}</td>
            <td>{transaction.delivered_count}</td>
            <td>{transaction.returned_count}</td>
            <td align="center">{transaction.reason || '-'}</td>
            {/* <td>{transaction.bottles_returned}</td> */}
            <td>{getTimeInIST(transaction.delivery_date).format(format_fancy)}</td>
        </tr>
      );
    }
}

export default withStyles(styles)(AgentReport);